class SwiftCode {
  address: string;
  address2: string;
  address3: string;
  bankDept: string;
  bankDescr: string;
  bic: string;
  centralBank: string;
  city: string;
  country: string;
  country2: string;
  extraAddrInfo: string;
  location: string;
  pob: string;
  prefix: string;
  subInfo: string;
  swiftConnFlag: string;
  valueAdded1: string;
  valueAdded2: string;
  zipCodeTown: string;

  constructor(
    address: string,
    address2: string,
    address3: string,
    bankDept: string,
    bankDescr: string,
    bic: string,
    centralBank: string,
    city: string,
    country: string,
    country2: string,
    extraAddrInfo: string,
    location: string,
    pob: string,
    prefix: string,
    subInfo: string,
    swiftConnFlag: string,
    valueAdded1: string,
    valueAdded2: string,
    zipCodeTown: string,
  ) {
    this.address = address;
    this.address2 = address2;
    this.address3 = address3;
    this.bankDept = bankDept;
    this.bankDescr = bankDescr;
    this.bic = bic;
    this.centralBank = centralBank;
    this.city = city;
    this.country = country;
    this.country2 = country2;
    this.extraAddrInfo = extraAddrInfo;
    this.location = location;
    this.pob = pob;
    this.prefix = prefix;
    this.subInfo = subInfo;
    this.swiftConnFlag = swiftConnFlag;
    this.valueAdded1 = valueAdded1;
    this.valueAdded2 = valueAdded2;
    this.zipCodeTown = zipCodeTown;
  }
}

export { SwiftCode };
